module.exports = __webpack_public_path__ + "img/production_managers.4c35e9b4.svg";